<template>
  <BFormCheckbox
    :id="id"
    v-model="data"
    :name="id"
    :value="true"
    :unchecked-value="false"
    :disabled="disabled"
    size="lg"
    @input="emitEvent"
  >
    <slot>
      <template v-if="text">{{ text }}</template>
    </slot>
  </BFormCheckbox>
</template>

<script>
import BaseFormControl from "@/components/Base/Form/BaseFormControl";

export default {
  name: "BaseAgreement",
  extends: BaseFormControl,
  props: {
    text: {
      type: String,
      default: ""
    },
    value: {
      type: [Number, Boolean],
      required: true
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/_variables";

.custom-control-input:checked ~ .custom-control-label:before {
  border-color: $col-polmed-blue;
  background-color: $col-polmed-blue;
}

.custom-control-label::before {
  border-color: $col-polmed-gray;
}

.custom-checkbox
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  border-color: $col-polmed-gray2;
  background-color: $col-polmed-gray2;
}
</style>
